//User Permissions
export const GET_MASTER_PERMISSIONS_REQUEST = "GET_MASTER_PERMISSIONS_REQUEST";
export const GET_MASTER_PERMISSIONS_SUCCESS = "GET_MASTER_PERMISSIONS_SUCCESS";
export const GET_MASTER_PERMISSIONS_FAILURE = "GET_MASTER_PERMISSIONS_FAILURE";